import DomLib from "./../Lib";
import ScrollTo from "./../ScrollTo";


/**
 * Object representation of an URL
 */
class Url {
    /**
     * Object representation of an URL
     *
     * @param {string} href
     * @constructor
     */
    constructor(href) {
        if (arguments.length > 0) {
            const location = typeof window !== 'undefined' ? window.location : {};
            let parser = document.createElement('a');
            parser.href = this._prepareDoubleStash('' + href);

            this._protocol = parser.protocol && parser.protocol !== ':' ? parser.protocol : location.protocol;  // => "http:"
            this._port = parser.port || location.port;                                                          // => "3000"
            this._hostname = parser.hostname || location.hostname;                                              // => "example.com"
            this._host = parser.host || (this._port ? this._hostname + ':' + this._port : this._hostname);      // => "example.com:3000"
            this._setPathname(parser.pathname || location.pathname);                                            // => "/pathname/"
            this._setHash(parser.hash);                                                                         // => "#hash"
            this._setSearch(parser.search);                                                                     // => "?search=test"
        } else {
            this._protocol = '';
            this._host = '';
            this._hostname = '';
            this._port = '';
            this._hash = '';
            this._search = '';
            this._setPathname('');
        }
    }

    /**
     * Returns a string representation of the URL object
     *
     * @return {string}
     */
    toString() {
        return (this._protocol ? this._protocol + '//' : '') +
            this._host +
            this._pathname +
            this._search +
            this._hash;
    }

    /**
     * Returns the hash
     *
     * @return {string}
     */
    get hash() {
        return this._hash;
    }

    /**
     * Adds the protocol if the URI starts with //
     *
     * @param {string} input
     * @returns String}
     * @private
     */
    _prepareDoubleStash(input) {
        if (input.substr(0, 2) === '//') {
            if (typeof window !== 'undefined') {
                return window.location.protocol + input;
            }
            return 'http:' + input;
        }
        return input;
    }

    /**
     * Sets the pathname
     *
     * @param {string} newValue
     * @private
     */
    _setPathname(newValue) {
        newValue = '' + newValue;
        if (!newValue || newValue[0] !== '/') {
            newValue = '/' + newValue;
        }
        this._pathname = newValue;
    }

    /**
     * Sets the hash
     *
     * @param {string} newValue
     * @private
     */
    _setHash(newValue) {
        newValue = '' + newValue;
        if (newValue && newValue.charAt(0) !== '#') {
            newValue = '#' + newValue;
        }
        this._hash = newValue;
    }

    /**
     * Sets the search
     *
     * @param {string} newValue
     * @private
     */
    _setSearch(newValue) {
        newValue = '' + newValue;
        if (newValue && newValue[0] !== '?') {
            newValue = '?' + newValue;
        }
        this._search = newValue;
    }
}

/**
 * Add a scroll-to animation to anchor links
 */
export default class SlowLink {
    /**
     * @param {HTMLElement[]|Node[]|NodeList} links
     * @param {object} options
     */
    constructor(links, options = {}) {
        this._options = options;
        DomLib.addEventListener(links, 'click', this.click.bind(this));
    }

    /**
     * @param {Url} uri
     * @private
     */
    _updateLocation(uri) {
        const stateObj = {uri: uri.toString()};
        history.pushState(stateObj, "Link", uri.toString());
    }

    /**
     * Handle the click on a slow link
     *
     * @param {MouseEvent} event
     * @param {HTMLElement} link
     */
    click(event, link) {
        event.preventDefault();
        const duration = parseInt(DomLib.data(link, 'slow-link') || this._options.duration || 500, 10);
        const uri = new Url(link.getAttribute('href'));
        const target = SlowLink.getTargetElementForUri(uri);
        const offset = parseInt(DomLib.data(link, 'slow-link-offset') || this._options.offset || 0, 10);
        if (target) {
            ScrollTo.scrollToAnimated(target, duration, offset);
            this._updateLocation(uri);
        }
    }

    /**
     * @param {Url} uri
     * @return {Element|null}
     */
    static getTargetElementForUri(uri) {
        try {
            return uri.hash ? document.querySelector(uri.hash) : null;
        } catch (e) {
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Ui/SlowLink.js